import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-tertiary)";

function IconUserAvatarPlaceholder({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M8.69 17.117a.486.486 0 0 0 .29-.002l13.422-3.867a.495.495 0 0 0 .244-.148c.142-.167.247-.366.308-.582.074-.266.078-.547.01-.814l-.156-.627a3.447 3.447 0 0 0-.817-1.518 3.145 3.145 0 0 0-1.42-.88s-.812-.131-1.33-.082c-.549.052-3.517.972-3.7 1.03a1.23 1.23 0 0 1-.019.005l-2.555.744-3.079.887a3.274 3.274 0 0 0-1.953 1.599 3.621 3.621 0 0 0-.329 2.594l.157.627c.067.268.202.51.392.7.153.153.336.267.535.334zM9.389 18.227a.473.473 0 0 0-.344.548c.265 1.258.898 2.412 1.707 3.387a7.15 7.15 0 0 0 3.396 2.283l3.157.978c.332.103.685.108 1.02.013.335-.095.639-.285.877-.55l2.271-2.514a7.74 7.74 0 0 0 1.86-3.77c.238-1.264.24-2.588-.118-3.811a.472.472 0 0 0-.589-.312L9.39 18.227z"/>
            <path fill={fill} d="M13.514 10.493 12.04 7.882a.521.521 0 0 1 .303-.757l2.063-.6c.32-.094.64.142.653.478l.114 3.007-1.66.483z"/>
        </svg>
    );
}

export default IconUserAvatarPlaceholder;
